<odl-dialog
  class="note-dialog"
  [label]="'DIALOG.NOTE.SHARED_TITLE' | translate"
  [open]="true"
  (odl-close)="dialogClosed.emit()"
>
  <div class="note-dialog-wrapper">
    <div class="note-dialog-wrapper__quote" [style.--note-color]="colorMap[note()!.color]">
      <span class="note-dialog-wrapper__highlight" [nrEllipsis]="3">
        {{ note()!.selectedText }}
      </span>
    </div>
    <!-- textContent: pre-wrap keeps the note's own line breaks, so no template whitespace. -->
    <p
      class="note-dialog-wrapper__notes note-dialog-wrapper__notes--read-only"
      [textContent]="note()!.notes"
    ></p>
  </div>
</odl-dialog>
